
import ListComponent from './ListComponent'

const Providers = () => {
    return (
        <ListComponent type="provider" />
    )
}

export default Providers